import ActionsDetail from './ActionsDetail';
import labels from '../../../constants/labels';
import {
  INTERNAL_SERVER_ERR_MSG,
  NO_DATA_FOUND_MSG,
  SINGLE_ROW_SELECTION_MSG,
} from '../../../constants/constants';
import fields from '../../../constants/fields';
import { apiPaths } from '../../../constants/paths';
import { callApiV2 } from '../../../utils/callApi';

export const defaultFilterData = {
  actionType: '',
  reqId: '',
  actionStatus: '',
};

export const actionTableProp = {
  tableNm: 'FXG_MyActions_ActionTable',
  tableHeading: '',
  resultsLabel: 'Available actions',
  clientEndOperation: true,
  inlineItemAction: true,
  errMsg: INTERNAL_SERVER_ERR_MSG,
  checkable: true,
  singleRowSelect: true,
  maxRowSelection: 1,
  maxRowSelectionErrMsg: SINGLE_ROW_SELECTION_MSG,
  emptyDataMsg: NO_DATA_FOUND_MSG,
  headers: [
    {
      sNo: 1,
      id: fields.creationDate,
      label: labels.DATE,
      display: true,
      type: 'date-range',
      filter: '',
    },
    {
      sNo: 2,
      id: fields.parsedReqId,
      label: labels.REQUEST_ID,
      display: true,
      filter: '',
    },
    {
      sNo: 3,
      id: fields.actionType,
      label: labels.ACTION,
      display: true,
      filter: '',
    },
    {
      sNo: 4,
      id: fields.entityName,
      label: labels.NAME,
      display: true,
      filter: '',
    },
    {
      sNo: 5,
      id: fields.actionStatus,
      label: labels.STATUS,
      display: true,
      filter: '',
    },
    {
      sNo: 6,
      id: fields.environment,
      label: labels.ENVIRONMENT,
      display: true,
      filter: '',
    },
  ],
  currentPage: 1,
  showLoader: true,
  showError: false,
  totalRows: 0,
  sortable: true,
  sortBy: fields.creationDate,
  expandable: true,
  expandableType: 'Component',
  expandableComponent: ActionsDetail,
  sortDirection: 'asc',
  rowKeyCol: 'rowId',
  itemsPerPage: 5,
  showFilter: false,
  rows: [],
  selectedRows: {},
  selectedRowsData: {},
  selection: { preview: false },
  actionList: [
    {
      sNo: 1,
      id: 'activate_fxAccount',
      label: 'Activate',
    },
  ],
};

export const actionSearchFormProp = {
  formHeader: 'Advanced Search',
  formFields: [
    {
      id: 0,
      label: labels.ACTION,
      name: fields.actionType,
      value: 'Activate FxAccount',
      suggestionList: [],
      type: 'static-select',
    },
    {
      id: 1,
      label: labels.REQUEST_ID,
      name: fields.reqId,
      value: '',
      type: 'search',
      apiPath: apiPaths.getRequestId,
      apiResultFiledNm: 'reqId',
      suggestionList: [],
      apiCallHelper: callApiV2,
    },
    {
      id: 2,
      label: labels.STATUS,
      name: fields.actionStatus,
      value: 'Pending',
      suggestionList: [],
      type: 'static-select',
    },
  ],
};

export const actionDetailFields = (timezone) => [
  {
    id: fields.creationDate,
    label: labels.RAISED_ON,
    isDate: true,
    timezone,
  },
  {
    id: 'parsedReqId',
    label: labels.REQUEST_ID,
  },
  {
    id: fields.entityName,
    label: labels.FX_ACCOUNT_NAME,
  },
  {
    id: fields.emailAddress,
    label: labels.CONTACT_EMAIL,
  },
  {
    id: fields.digitalAssetGroup,
    label: labels.DIGITAL_ASSETS_GROUP,
  },
  {
    id: fields.amexContactEmail,
    label: labels.AMEX_CONTACT,
  },
  {
    id: fields.protocols,
    label: labels.PROTOCOL,
  },
];
